/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {provideLegacyDisputeReviewV2} from '../api'

export const useMutationProvideLegacyDisputeReviewV2 = createReactQueryMutationHook('provideLegacyDisputeReviewV2', provideLegacyDisputeReviewV2)
